export enum EUserStatus {
  NEW = 'NEW',
  TRIAL = 'TRIAL',
  KYC_PASSED = 'KYC_PASSED',
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
}

export enum EUserType {
  SUPER_ADMIN = 'SUPER_ADMIN',
  USER = 'USER',
  ADMIN = 'ADMIN',
}

export const Tiers = {
  TIER_0: 0,
  TIER_1: 1,
};
